import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ContactFilterAtom } from "../../../atoms/ContactFilterAtom";
import {
  ClearFilterAtom,
  ContactResetTagSelect,
  FilterCounterAtom,
} from "../../../atoms/ContactFilterAtoms";
import { CountedSavedSearchesAtom } from "../../../atoms/SavedSearches";
import { IOption } from "../../../types/CommonTypes";
import SavedSearchSelect from "../../SavedSearch/SavedSearchSelect";
import { SavedSearches } from "./SidebarStyles";

export default function FilterBySavedSearch() {
  const [contactFilter, setContactFilter] = useRecoilState(ContactFilterAtom);
  const setFilterCounter = useSetRecoilState(FilterCounterAtom);

  const [resetTagSelect, setResetTagSelect] = useRecoilState(
    ContactResetTagSelect
  );
  const shouldClear = useRecoilValue(ClearFilterAtom);

  useEffect(() => {
    if (shouldClear) setResetTagSelect(true);
  }, [shouldClear]);

  useEffect(() => {
    if (resetTagSelect) {
      setTimeout(() => {
        setResetTagSelect(false);
      }, 100);
    }
  }, [resetTagSelect]);

  const countedSavedSearches = useRecoilValue(CountedSavedSearchesAtom);
  const [selectedSavedSearch, setSelectedSavedSearch] = useState<IOption>(
    contactFilter?.savedSearchName
      ? {
          name: contactFilter.savedSearchName,
          value: contactFilter.savedSearchName,
        }
      : {
          name: "",
          value: "",
        }
  );

  const savedSearchesSuggestions = countedSavedSearches.map((savedSearch) => ({
    value: savedSearch.id,
    name: savedSearch.name,
    icon: "tag",
    suffix: `${savedSearch.contactsCount}`,
  }));

  useEffect(() => {
    if (contactFilter?.savedSearchName) {
      setSelectedSavedSearch({
        name: contactFilter.savedSearchName,
        value: contactFilter.savedSearchName,
      });
    }
  }, [contactFilter]);

  async function selectedSearchModal(savedSearchOption: IOption) {
    if (savedSearchOption.value === "") {
      setContactFilter(null);
    }

    setSelectedSavedSearch(savedSearchOption);
    const selectedSavedSearch = countedSavedSearches.find(
      ({ id }) => savedSearchOption.value === id
    );

    if (!selectedSavedSearch) return;

    setContactFilter((oldFilter) => ({
      ...oldFilter,
      withTags: [],
      withoutTag: [],
      allOfTags: [],
      savedSearchName: selectedSavedSearch.name,
      tagQuery: selectedSavedSearch.search,
    }));
  }

  useEffect(() => {
    const bySavedSearch = contactFilter?.savedSearchName ? 1 : 0;
    setFilterCounter((oldCounts) => ({
      ...oldCounts,
      bySavedSearchCount: bySavedSearch,
    }));
  }, [contactFilter?.savedSearchName]);

  return (
    <>
      <SavedSearches>
        <SavedSearchSelect
          isFilter
          options={savedSearchesSuggestions}
          onOptionSelect={selectedSearchModal}
          selectedOption={selectedSavedSearch}
          placeholder="Type or select saved search"
          isFilterContactReset={resetTagSelect}
        />
      </SavedSearches>
    </>
  );
}
